import { useState, useEffect } from 'react';
import { SummaryData, VideoData } from '../types/socialGlass';
import { fetchSummaryData, fetchVideoData } from '../services/socialGlassApi';

export const useSocialGlassData = () => {
  const [summaryData, setSummaryData] = useState<SummaryData | null>(null);
  const [idToData, setIdToData] = useState<Record<string, VideoData>>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchSummaryData();
        setSummaryData(data);

        // Fetch video data for all posts
        const allPosts = [
          ...(data.TopPosts
            ? Object.values(data.TopPosts).flatMap((category) => [
                ...category.HottestPosts,
                ...category.BreakoutContent,
              ])
            : []),
          ...(data.TopBrandsAndTitles
            ? data.TopBrandsAndTitles.flatMap((brand) => brand.brandRelatedPosts)
            : []),
          ...(data.TopCreators
            ? data.TopCreators.flatMap((creator) => creator.creatorRelatedSubmittedPosts)
            : []),
        ];

        if (allPosts.length > 0) {
          const postIds = allPosts
            .filter((post) => post.postId && post.postId !== "")
            .map((post) => String(post.postId));

          const videoData = await fetchVideoData(postIds);
          setIdToData(videoData);
        }

        setLoading(false);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return {
    summaryData,
    idToData,
    loading,
    error,
  };
};
